import { Utils } from 'cc-common';

export class BaseWorkOrderParameterDto {
    communityId: number;
    customerId: string;
    workOrderId: number;

    getQueryString(): string {
        const tokens: Array<string> = [];
        if (Utils.notNullAndDefined(this.communityId)) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (Utils.notNullAndDefined(this.workOrderId)) {
            tokens.push(`workOrderId=${this.workOrderId}`);
        }
        if (Utils.notNullOrEmpty(this.customerId)) {
            tokens.push(`customerId=${this.customerId}`);
        }

        return Utils.notNullOrEmpty(tokens) ? `?${tokens.join('&')}` : '';
    }
}
